import React, { ReactElement } from 'react'

function Step6Tooltip(): ReactElement {
  return (
    <div className="card cardSm textPrimaryDark w23 fontSizeXs">
      <p>
        Ce document résume l’ensemble de vos informations importantes et
        constitue une auto-certification que vous devez signer.
      </p>
      <p>
        Il permettra de régulariser votre situation et sera enregistré dans nos
        bases de manière sécurisée et dans le respect de notre Politique de
        Confidentialité.
      </p>
    </div>
  )
}

export default Step6Tooltip
